import PropTypes from "prop-types";
import React from "react";
import { Box, Typography } from "@mui/material";
import CourseTypeIcon from "../../Icons/CourseTypeIcon";
import CourseFlags from "../../Icons/CourseFlags";
import AssignmentDate from "../../Assignment/AssignmentDate";
import { Tooltip } from "../../Tooltip";
import { courseTypes } from "../../../constants/index";

const LearningPathAssignmentInfo = ({ assignment }) => {
  const assignmentInfo = (
    <Box display="flex" flexDirection="column" pl={2} width={416}>
      <Box display="flex" alignItems="flex-start">
        <Box mr={2}>
          <CourseTypeIcon type={assignment.typeName} size="small" />
        </Box>
        <CourseFlags flags={assignment.flags} size="small" />
      </Box>
      <Typography variant="body1" color="textPrimary">
        {assignment.typeName == courseTypes.policy
          ? assignment.title + " | " + assignment.number
          : assignment.title}
      </Typography>
      <AssignmentDate assignment={assignment} />
    </Box>
  );

  return assignment.content ? (
    <Tooltip
      title={
        <Typography variant="body2" color="textPrimary">
          {assignment.content}
        </Typography>
      }
    >
      {assignmentInfo}
    </Tooltip>
  ) : (
    assignmentInfo
  );
};

export default LearningPathAssignmentInfo;

LearningPathAssignmentInfo.propTypes = {
  assignment: PropTypes.any
};
